import * as React from "react";
import { AwardResult } from "models/ApiModels";
import { AwardType } from "models/ApiEnums";
import { Trans } from 'react-i18next';

interface IProps {
    award: AwardResult;
}

export const AwardSnackbarMessage: React.FC<IProps> = (props) => {
    return <Trans i18nKey={`Components.AwardSnackbarMessage.${AwardType[props.award.awardType]}`} count={props.award.points} />;
};